import BlogPostCollectionMoreItems from "./BlogPostCollectionMoreItems";

export default BlogPostCollectionMoreItems;
